const PromotionalCards = () => {
    const promotions = [
        {
            title: "Grow Your Earnings",
            description:
                "Invite friends and earn up to 5,000 MAC tokens in rewards!",
            buttonText: "Invite Friends",
        },
        {
            title: "Upgrade Your Plan",
            description:
                "Maximize your earnings with our premium investment plans!",
            buttonText: "Upgrade Plans",
        },
    ];

    return (
        <div className="row g-4 mb-4">
            {promotions.map((promo, index) => (
                <div className="col-12" key={index}>
                    <PromotionalCard
                        title={promo.title}
                        description={promo.description}
                        buttonText={promo.buttonText}
                    />
                </div>
            ))}
        </div>
    );
};

const PromotionalCard = ({ title, description, buttonText }) => {
    return (
        <div className="card">
            <div className="card-body p-4">
                <h3 className="text-white fs-4 fw-bold mb-2">{title}</h3>
                <p className="text-secondary mb-4">{description}</p>

                <button
                    className="btn btn-primary px-4 py-2"
                    style={{
                        borderRadius: "8px",
                    }}
                >
                    {buttonText} <span className="ms-2">→</span>
                </button>
            </div>
        </div>
    );
};

export default PromotionalCards;
